import classNames from "classnames";
import * as React from "react";

interface TermsProps {
  onTermsChange: (checked: boolean) => void;
  onPolicyChange: (checked: boolean) => void;
  hasError?: boolean;
  id: string;
}

export function Terms({
  onTermsChange,
  onPolicyChange,
  hasError,
  id,
}: TermsProps) {
  const wrapperStyles = classNames(
    "custom-checkbox group mb-1",
    hasError && "text-danger-600 hover:text-red-800"
  );

  const inputStyles = classNames(
    "custom-checkbox-input",
    hasError &&
      "border-danger-600 focus:border-danger-600 group-hover:border-red-800"
  );

  const labelStyles = "custom-checkbox-label";

  const termsId = `${id}-terms-and-conditions`;
  const privacyId = `${id}-privacy-policy`;

  return (
    <div className="space-y-2">
      <div className={wrapperStyles}>
        <input
          type="checkbox"
          onChange={(e) => onTermsChange(Boolean(e.target.checked))}
          name={termsId}
          id={termsId}
          className={inputStyles}
          required
        />
        <label htmlFor={termsId} className={labelStyles}>
          I agree to the{" "}
          <a
            href="/docs/terms-and-conditions.pdf"
            target="_blank"
            className="underline hover:no-underline"
          >
            Terms and Conditions
          </a>
        </label>
      </div>

      <div className={wrapperStyles}>
        <input
          type="checkbox"
          onChange={(e) => onPolicyChange(Boolean(e.target.checked))}
          name={privacyId}
          id={privacyId}
          className={inputStyles}
          required
        />
        <label htmlFor={privacyId} className={labelStyles}>
          I agree to the{" "}
          <a
            href="/privacy-policy"
            target="_blank"
            className="underline hover:no-underline"
          >
            Privacy Policy
          </a>
        </label>
      </div>
    </div>
  );
}
